"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.White = 0;
exports.Black = 1;
exports.WIDTH = 8;
exports.HEIGHT = 8;



/*****************
 ** WEBPACK FOOTER
 ** ../brchess-core/dist/constantes.js
 ** module id = 1
 ** module chunks = 0
 **/